import React, { useContext, useRef, useState, useEffect } from "react";

import Accordion from "@mui/material/Accordion";
import Button from "@mui/material/Button";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CencusButton from "ui/elements/census/CencusButton";
import CensusExploreDropDownGroup from "ui/elements/census/CensusExploreDropDownGroup";
import CensusBarChartWithLegend from "ui/components/census/CensusBarChartWithLegend";
import { DashboardContext } from "states/DashboardContext";
import CensusService from "_services/Census/CensusService";
import CensusTableLayout from "ui/elements/census/CensusTableLayout";
import CensusFloatingLegend from "ui/elements/census/CensusFloatingLegend";
import Divider from "@mui/material/Divider";
import CensusMapWithLegend from "ui/components/census/CensusMapWithLegend";
import CensusLoadingCmp from "ui/elements/census/CensusLoadingCmp";

import CensusDragDropPane from "ui/elements/census/CensusDragDropPane";

const censusService = CensusService();

const CensusDataExplorer = () => {
  const {
    selectedYearState,
    censusSelectedIndicatorState,
    censusSelectedAreasState,
    censusMapDataState,
    censusIsDefaultDataState,
    censusDefaultMapDataState,
    loadingState,
    filterItemState,
    rowItemState,
    columnItemState,
  } = useContext(DashboardContext);

  const [censusMapData, setCensusMapData] = censusMapDataState;
  const [censusSelectedIndicator, setCensusSelectedIndicator] =
    censusSelectedIndicatorState;
  const [selectedYear, setSelectedYear] = selectedYearState;
  const [censusSelectedAreas, setCensusSelectedAreas] =
    censusSelectedAreasState;
  const [censusIsDefaultData, setCensusIsDefaultData] =
    censusIsDefaultDataState;
  const [censusDefaultMapData, setCensusDefaultMapData] =
    censusDefaultMapDataState;
  const [loading, setLoading] = loadingState;
  const [filterItem, setFilterItem] = filterItemState;
  const [rowItem, setRowItem] = rowItemState;
  const [columnItem, setColumnItem] = columnItemState;
  const visualSelection = ["Map", "Bar Chart", "Table"];
  const [selectedButton, setSelectedButton] = useState(2);
  const [isAllVisual, setIsAllVisual] = useState(true);
  const handleSelectedButtonChange = (index) => setSelectedButton(index);
  const [isLoading, setIsLoading] = useState();

  const indicatorkey = censusSelectedIndicator
    .map((ind) => ind.indicatorkey)
    .join();

  const timevaluekey = selectedYear.map((year) => year.timevaluekey).join();

  const areakey = censusSelectedAreas.map((areas) => areas.areakey).join();

  const subgroupkey = censusSelectedIndicator
    .map((sub) => sub.subgroupkey)
    .join();

  async function fetchIndicatorDataValue() {
    setLoading(true);
    const response = await censusService.getIndicatorDataValue(
      indicatorkey,
      subgroupkey,
      timevaluekey,
      areakey
    );

    setCensusMapData(response);
    setCensusIsDefaultData(false);
    setLoading(false);
  }

  const handleClearAllSelection = () => {
    setCensusSelectedAreas([]);
    setSelectedYear([]);
    setCensusSelectedIndicator([]);
  };

  return (
    <div>
      <div className="">
        <div>
          <Accordion
            defaultExpanded
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0)",
              p: 0,
              m: 0,
              minHeight: "28px",
              boxShadow: "none",
            }}
          >
            <AccordionSummary
              sx={{
                backgroundColor: "#fff",
                minHeight: "4px", // Reduce the default minimum height
                "&.Mui-expanded": {
                  minHeight: "32px", // Height when expanded
                },
                "& .MuiAccordionSummary-content": {
                  margin: "4px 0", // Adjust vertical margin to align content properly
                },
                "&.Mui-expanded .MuiTypography-root": {
                  display: "none",
                },
                "&.Mui-expanded": {
                  minHeight: "24px",
                },
                "& .MuiAccordionSummary-content": {
                  margin: "0px",
                },
                "& .MuiAccordionSummary-content.Mui-expanded": {
                  margin: "0px",
                },
              }}
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <Typography sx={{ fontSize: "12px", color: "gray" }}>
                Expand Filter to Select Indicators
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                // Remove inner padding so the details area does not add extra height
                p: "0 12px 0 12px",
                m: 0,
              }}
            >
              <CensusExploreDropDownGroup />
              <div className=" flex justify-between">
                <Button
                  onClick={handleClearAllSelection}
                  size="small"
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    minWidth: "auto",
                    lineHeight: 1,
                    height: "20px",
                    minHeight: 0,
                  }}
                  disabled={[
                    selectedYear,
                    censusSelectedAreas,
                    censusSelectedIndicator,
                  ].every(
                    (arr) =>
                      Array.isArray(arr) && arr.every((item) => item === null)
                  )}
                >
                  Clear All
                </Button>
                <Button
                  onClick={fetchIndicatorDataValue}
                  size="small"
                  variant="outlined"
                  sx={{
                    textTransform: "none",
                    fontWeight: "bold",
                    fontSize: "0.75rem",
                    minWidth: "auto",
                    lineHeight: 1,
                    height: "20px",
                    minHeight: 0,
                  }}
                  disabled={
                    !(indicatorkey && subgroupkey && areakey && timevaluekey)
                  }
                >
                  Update
                </Button>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>

      {/* Map, Bar and Table visualization */}

      <div className="items-center justify-center w-full h-full bg-white rounded-lg shadow-md md:basis-5/5">
        <div style={{ display: selectedButton !== 2 ? "block" : "none" }}>
          <CensusFloatingLegend />
        </div>
        {/* <Divider /> */}
        {Array.isArray(censusMapData) && censusMapData.length > 0 && (
          <div className="flex w-full lg:flex-row flex-col justify-center bg-transparent ">
            {loading ? <CensusLoadingCmp /> : <CensusTableLayout />}
          </div>
        )}
      </div>
    </div>
  );
};

export default CensusDataExplorer;
